import * as Toggle from "@radix-ui/react-toggle";
import PlusIcon from "./icons/AikaIcons/PlusIcon";
import MinusIcon from "./icons/AikaIcons/MinusIcon";
import { useField } from "formik";

export default function TogglePlusMinus(props: { name: string }) {
  const [, meta, helpers] = useField<string | undefined>(props.name);
  const { value } = meta;
  const { setValue } = helpers;
  return (
    <Toggle.Root
      pressed={value === "-"}
      onPressedChange={() => {
        if (value === "-") {
          setValue("+");
        } else {
          setValue("-");
        }
      }}
      className="btn btn--toggle"
      aria-label={
        value === "-"
          ? "Negativ værdi, tryk for at skifte"
          : "Positiv værdi, tryk for at skifte"
      }
      title="Skift mellem positiv og negativ værdi"
    >
      <span className="icon icon-plus bg-success bg-opacity-10 text-success">
        <PlusIcon width={18} />
      </span>
      <span className="icon icon-minus bg-danger bg-opacity-10 text-danger">
        <MinusIcon width={16} />
      </span>
    </Toggle.Root>
  );
}
